// extracted by mini-css-extract-plugin
export default {"checkIcon":"PurchaseSuccessPage_checkIcon__MaYDe","buttonContainer":"PurchaseSuccessPage_buttonContainer__w0djF"};